// @flow

import { slideUp, slideDown } from "./slide";

class VenueSpaceShowHide {
    el: HTMLElement;
    target: HTMLElement;
    isShown: boolean;
    originalText: string;
    textEl: ?HTMLElement;
    hideCTA: ?HTMLElement;

    constructor(el: HTMLElement) {
        this.el = el;
        const target = document.getElementById(
            this.el.getAttribute("data-target") || ""
        );
        if (!target) return;
        this.target = target;
        this.textEl = this.el.querySelector(".cta-tag__text");
        this.hideCTA = target.querySelector(".venue-space-show-hide");
        this.originalText = this.target.textContent;

        // Hide all by default
        slideUp(this.target, 0);

        // Attach handlers
        this.attachHandlers();
    }

    attachHandlers = () => {
        this.el.addEventListener("click", () => {
            if (this.isShown) {
                this.hide();
            } else {
                this.show();
            }
        });
        if (this.hideCTA) {
            this.hideCTA.addEventListener("click", this.hide);
        }
    };

    show = () => {
        this.isShown = true;
        slideDown(this.target);
        if (this.textEl) {
            this.originalText = this.textEl.textContent;
            this.textEl.innerHTML = "Hide details";
        }
        this.el.classList.add("active");
    };

    hide = () => {
        this.isShown = false;
        if (this.textEl) {
            this.textEl.innerHTML = this.originalText;
        }
        slideUp(this.target);
        this.el.classList.remove("active");
    };
}

const els = document.querySelectorAll(".venue-space-show-hide");
els.forEach((el: HTMLElement) => {
    new VenueSpaceShowHide(el);
});
